import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

/**
 * <CreateFolderDialog selected onCreateFolder = {folder} onCancel = {} />
 */

class CreateFolderDialog extends Component {

	state = {
		name: "",
	}

	isReadyToCreate() {
		return this.state.name !== ""
	}

	getFolderId = selected => selected ? (selected.type.toString() === "0" ? selected.id : selected.folder_id ) : "0"

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Создать папку
			</DialogTitle>

			<DialogContent style = {{display: "flex", flexDirection: "column"}}>

				<TextField
					value = {this.state.name}
					label = "Название папки"
					margin = "normal"
					onChange = {e => {
						this.setState({
							name: e.target.value
						})
					}}
				/>

			</DialogContent>

			<DialogActions>

				<Button
					disabled = {!this.isReadyToCreate()}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreateFolder === "function") {
							this.props.onCreateFolder({
								name: this.state.name,
								code: "",
								type: "0",
								folderId: this.getFolderId(this.props.selected),
							})
						}
					}}
				>Создать</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default CreateFolderDialog
